import VueRouter from "vue-router";

import Login from "@/Login/ui/Login.vue";
import Dashboard from "@/Dashboard/ui/Dashboard.vue";
import { isLoggedIn } from "@/App/middlewares";

const routes = [
  {
    path: "/",
    name: "dashboard",
    component: Dashboard
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/cases",
    name: "cases",
    component: () => import("@/Cases/ui/Cases.vue")
  },
  {
    path: "/cases/:id",
    name: "case",
    component: () => import("@/Case/ui/Case.vue")
  },
  {
    path: "/trucks",
    name: "trucks",
    component: () => import("@/Trucks/ui/Trucks.vue")
  },
  {
    path: "/users",
    name: "users",
    component: () => import("@/Users/ui/Users.vue")
  },
  {
    path: "/broadcast-messages",
    name: "broadcast-messages",
    component: (): any => import("@/BroadcastMessages/ui/BroadcastMessages.vue")
  }
];

/staging|localhost/.test(window.location.host) &&
  routes.push({
    path: "/team",
    name: "Team",
    component: (): any => import("@/Team/Team.vue")
  });

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(isLoggedIn);

export default router;
